import React from 'react'

export const tablePrevisionelColumnTittles = [
    {
        id: 1,
        tittle: "Pays de production",
        property: "pays.libelle",
        toSort: true
    },
    {
        id: 2,
        tittle: "Bu",
        property: "bus.libelle",
        toSort: true
    },
    {
        id: 3,
        tittle: "Client",
        property: "clients.libelle",
        toSort: true
    },
    {
        id: 4,
        tittle: "Operation",
        property: "operations.libelle",
        toSort: true
    },
    {
        id: 5,
        tittle: " Code article",
        property: "code_articles.libelleCodeArticle",
        toSort: false
    },
    {
        id: 6,
        tittle: "Désignation article",
        property: "articles.libelle",
        toSort: true
    },
    {
        id: 7,
        tittle: "Mois",
        property: "mois",
        toSort: true
    },
    {
        id: 8,
        tittle: "Annee",
        property: "annee",
        toSort: true
    },
    {
        id: 9,
        tittle: "Forecast Heures",
        property: "saisie_managers.heures_ca",
        toSort: false
    },
    {
        id: 10,
        tittle: "Forecast Actes",
        property: "saisie_managers.actes",
        toSort: false
    }, {
        id: 11,
        tittle: "Actions",
        toSort: false,
      }
];

export interface PrevisionnelInterface {
    id: number
    pays_id: number
    pays_libelle: string
    bu_id: number
    bu_libelle: string
    client_id: number
    client_libelle: string
    operation_id: number
    operation_libelle: string
    article_id: number
    article_libelle: string
    devises_id: number
    devises_libelle: string
    code_article_id: number
    code_article_libelle: string
    heure_prev: any
    acte_prev: number
    annee: number
    mois: number
  }

const PrevisionnelQuantiteInterface = () => {
  return (
    <div>
      
    </div>
  )
}

export default PrevisionnelQuantiteInterface
